import { _endpointWarehouseAgency } from "../../utils/provider";
import {
    _createRequest,
    _getFilter,
    _fetch,
    _pick,
    _normalizeSearchText,
} from "../../utils/helper";
const endpoint = (rawProps) => {
    const { type } = rawProps;
    const objectFilter = { "aw.agency_id": "eq", "p.quantity": "lte" };
    // Never mutate the caller's params/filter objects in place — `filter`
    // here can be the EXACT SAME object react-admin's <Filter> form (or
    // ReferenceManyField) is still holding onto in its own Redux state
    // (e.g. warehouseAgencies/list.js's refetchCurrentPage passes its
    // `filterValues` prop straight through). Renaming/deleting keys on
    // that shared object behind react-admin's back corrupted it: clearing
    // the search box removed "warehouse_search" from the form's own state,
    // but the "p.name_search" key this code had secretly added earlier
    // was never known to the form and so never got cleared, leaking the
    // stale search into every request until a full page reload.
    const params = { ...rawProps.params, filter: { ...(rawProps.params && rawProps.params.filter) } };
    // The search box's <TextInput source> is intentionally dot-free
    // ("warehouse_search", see warehouseAgencies/list.js) because
    // react-admin's <Filter> form (react-final-form) treats a dotted
    // source as a nested path, not a literal flat key — so remap it here
    // to the real filter column. (agencies/detail.js's Warehouse tab
    // instead sets "p.name_search" directly as a plain filter prop, no
    // form involved, so it already arrives as a flat key and skips this.)
    if (typeof params.filter["warehouse_search"] === "string") {
        params.filter["p.name_search"] = params.filter["warehouse_search"];
        delete params.filter["warehouse_search"];
    }
    // Search box (Nhà kho / Agency > Show > Warehouse) filters against the
    // pre-normalized products.name_search column (see migration 1058), so
    // the search term must be normalized the same way before being sent.
    // An empty/whitespace-only value is removed entirely rather than sent
    // as an ILIKE '%%' (matches-everything but pointless) condition.
    if (typeof params.filter["p.name_search"] === "string") {
        const trimmed = params.filter["p.name_search"].trim();
        if (trimmed) {
            params.filter["p.name_search"] = _normalizeSearchText(trimmed);
        } else {
            delete params.filter["p.name_search"];
        }
    }
    const sort = !Array.isArray(params.sort) ? [params.sort] : params.sort;

    switch (type) {
        case "manyReference": {
            const { target = "aw.id" } = params;
            if (params.id) {
                params.filter = {
                    ...params.filter,
                    [target]: params.id,
                };
            }
            return _fetch(
                _createRequest(_endpointWarehouseAgency.statisticv2, true, {
                    filter: _getFilter(params, objectFilter),
                })
            );
        }
        case "suppendProduct": {
            return fetch(
                _createRequest(_endpointWarehouseAgency.suppendProduct, true, {
                    ..._pick(params, ["agency_warehouse_id", "is_suppend"]),
                })
            )
                .then((res) => res.json())
                .then((res) => {
                    res.data = res.data || {};
                    return res;
                });
        }

        default: {
            //list
            return _fetch(
                _createRequest(_endpointWarehouseAgency.statisticv2, true, {
                    filter: _getFilter(
                        {
                            ...params,
                            sort: [...sort, { field: "aw.id", order: "ASC" }],
                        },
                        {
                            ...objectFilter,
                            quantity: "lt",
                        }
                    ),
                })
            );
        }
    }
};

export default endpoint;
